import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withLookup$1 from './withLookup.js';
import { getLookupData } from '../../modules/lookups/selectors.js';
import { lookupRequest, lookupReset } from '../../modules/lookups/actions.js';
import { compareParams } from '../../modules/utility/params.js';

var LookupBase = /*#__PURE__*/function (_React$Component) {
  _inherits(LookupBase, _React$Component);

  var _super = _createSuper(LookupBase);

  function LookupBase() {
    var _this;

    _classCallCheck(this, LookupBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_renderWarning", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          lookupRequest = _this$props.lookupRequest,
          lookup = _this$props.lookup,
          lookupParams = _this$props.lookupParams,
          lookupOptions = _this$props.lookupOptions,
          lookupData = _this$props.lookupData,
          onLoad = _this$props.onLoad; // re-request if lookup was reset or params changed

      if (lookup && (lookup !== prevProps.lookup || !lookupData.date && prevProps.lookupData.date || !compareParams(lookupParams, prevProps.lookupParams))) {
        if (onLoad) onLoad();
        lookupRequest(lookup, lookupParams, lookupOptions).then(_this.onRequestCompleted);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var _this$props2 = _this.props,
          lookupReset = _this$props2.lookupReset,
          lookup = _this$props2.lookup,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions,
          onReset = _this$props2.onReset;
      if (!lookup) return;
      lookupReset(lookup, lookupParams, lookupOptions);
      if (onReset) onReset(); // re-requesting handled in componentDidUpdate
    });

    _defineProperty(_assertThisInitialized(_this), "onRequestCompleted", function () {
      if (!_this._isMounted) return;
      var _this$props3 = _this.props,
          onLoaded = _this$props3.onLoaded,
          lookupData = _this$props3.lookupData;
      if (onLoaded) onLoaded(lookupData);
    });

    return _this;
  }

  _createClass(LookupBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          lookupRequest = _this$props4.lookupRequest,
          lookupReset = _this$props4.lookupReset,
          lookup = _this$props4.lookup,
          lookupParams = _this$props4.lookupParams,
          lookupOptions = _this$props4.lookupOptions,
          resetOnMount = _this$props4.resetOnMount,
          onLoad = _this$props4.onLoad,
          onReset = _this$props4.onReset;
      this._isMounted = true;
      if (!lookup) return;

      if (resetOnMount) {
        lookupReset(lookup, lookupParams, lookupOptions);
        if (onReset) onReset();
      }

      if (onLoad) onLoad();
      lookupRequest(lookup, lookupParams, lookupOptions).then(this.onRequestCompleted);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props5 = this.props,
          lookupReset = _this$props5.lookupReset,
          lookup = _this$props5.lookup,
          lookupParams = _this$props5.lookupParams,
          lookupOptions = _this$props5.lookupOptions,
          resetOnUnmount = _this$props5.resetOnUnmount,
          onReset = _this$props5.onReset;
      this._isMounted = false;

      if (lookup && resetOnUnmount) {
        lookupReset(lookup, lookupParams, lookupOptions);
        if (onReset) onReset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          render = _this$props6.render,
          children = _this$props6.children,
          lookupData = _this$props6.lookupData;
      var resetLookup = this.reset;

      if (render && children && !this._renderWarning) {
        this._renderWarning = true;
        console.warn("Lookup should be passed either render or children prop, not both");
      }

      if (render) {
        return render(lookupData, resetLookup) || null;
      }

      if (children) {
        return children(lookupData, resetLookup) || null;
      }

      return null;
    }
  }]);

  return LookupBase;
}(React.Component);

_defineProperty(LookupBase, "propTypes", {
  render: _pt.func,
  resetOnMount: _pt.bool,
  resetOnUnmount: _pt.bool,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  onReset: _pt.func,
  children: _pt.func,
  lookup: _pt.any,
  lookupAction: _pt.func,
  lookupParams: _pt.any,
  lookupOptions: _pt.any,
  lookupData: _pt.any.isRequired,
  lookupRequest: _pt.func.isRequired,
  lookupReset: _pt.any.isRequired
});

_defineProperty(LookupBase, "defaultProps", {
  resetOnMount: false,
  resetOnUnmount: false
});

var mapStateToProps = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup,
      lookupParams = _ref.lookupParams,
      lookupOptions = _ref.lookupOptions;
  return {
    lookupData: getLookupData(state, lookup, lookupParams, lookupOptions)
  };
};

var actions = {
  lookupRequest: lookupRequest,
  lookupReset: lookupReset
};

var connectBase = function connectBase() {
  return connect(mapStateToProps, actions);
};

var LookupBaseComponent = compose(withLookup$1({
  autoNamePrefix: "Lookup/"
}), connectBase())(LookupBase);
/**
 * A helper to load and display lookup data
 */

var Lookup = function Lookup(props) {
  return /*#__PURE__*/React.createElement(LookupBaseComponent, props);
};

Lookup.propTypes = {
  render: _pt.func,
  resetOnMount: _pt.bool,
  resetOnUnmount: _pt.bool,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  onReset: _pt.func,
  children: _pt.func,
  lookup: _pt.any,
  lookupAction: _pt.func,
  lookupParams: _pt.any,
  lookupOptions: _pt.any
};
var Lookup$1 = Lookup;

export { Lookup$1 as default };
